import React, { Component } from "react"

/* Icons */
import { LoadingOutlined } from '@ant-design/icons'

/* Sweet Alert */
import Swal from 'sweetalert2'

/* REST API */
import { register } from '../../../api/User'

/* Helpers */
import { withRouter } from '../../../helpers'

/* Router */
import { Link } from "react-router-dom"

/*
    Page Register
*/

class CreatePartner extends Component {

    constructor() {
        super()

        this.state = {
            name: "",
            email: "",
            password: "",
            repeat: "",
            loading: "",
            secure: false
        }
    }


    /* Register action */
    register = () => {

        const { name, email, password, repeat } = this.state

        const { navigate } = this.props

        if (name === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите свое имя', showConfirmButton: false, timer: 1500 })
            return
        }

        if (email === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите Email', showConfirmButton: false, timer: 1500 })
            return
        }

        if (!/^\S+@\S+\.\S+$/.test(email)) {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Неправильный Email', showConfirmButton: false, timer: 1500 })
            return
        }

        if (password === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите пароль', showConfirmButton: false, timer: 1500 })
            return
        }

        if (password.length < 8) {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите пароль больше 8 символов', showConfirmButton: false, timer: 1500 })
            return
        }

        if (password !== repeat) {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Пароли не совпадают', showConfirmButton: false, timer: 1500 })
            return
        }

        this.setState({ loading: true })


        register({ name, email, password }).then(response => {
            if (response.status === 200) {

                this.setState({
                    name: "",
                    email: "",
                    password: "",
                    repeat: "",
                    loading: "",
                    secure: false
                })

                Swal.fire({
                    icon: 'success',
                    title: 'Вы успешно добавили партнера',
                    text: '',
                    showConfirmButton: false,
                })

                setTimeout(() => {
                    navigate('/partners')
                }, 1000)

            }
            else if (response.status === 401) {
                Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Клиент с таким email уже существует', showConfirmButton: false, timer: 1500 })
            }
            else {
                Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Что-по пошло не так! Попробуйте позднее', showConfirmButton: false, timer: 1500 })
            }
        }).catch(() => {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Что-по пошло не так! Попробуйте позднее', showConfirmButton: false, timer: 1500 })
        }).finally(() => {
            this.setState({ loading: false })
        })
    }


    /* Draw Top */
    _top = () => {
        return (
            <div className="content-top">

                <div className="content-name">
                    <img src="/pictures/category.png" alt="Category" />
                    <p>Создать партнера</p>
                </div>

            </div>
        )
    }


    render = () => {

        const { name, email, password, repeat, loading, secure } = this.state

        return (

            <div className="content">

                {this._top()}

                <div className="login-page">

                    <div className="login-box">

                        <div className="login-logo">
                            <img src="/pictures/icon.png" alt="Icon" />
                            <h2>TGC GROUP</h2>
                        </div>

                        <div className="form-box">
                            <img src="/pictures/account.png" alt="Account" />
                            <input placeholder="Имя партнера" value={name} onChange={event => this.setState({ name: event.target.value })} />
                        </div>

                        <div className="form-box">
                            <img src="/pictures/mail.png" alt="Mail" />
                            <input placeholder="Email" value={email} onChange={event => this.setState({ email: event.target.value })} />
                        </div>

                        <div className="form-box">
                            <img src="/pictures/lock.png" alt="Lock" />
                            <input placeholder="Создайте пароль" type={secure ? "text" : "password"} value={password} onChange={event => this.setState({ password: event.target.value })} />
                            <div className="login-secure" onClick={() => this.setState({ secure: !secure })}>
                                {secure ? <img className="hide" src="/pictures/hide.png" alt="Eye" /> : <img src="/pictures/show.png" alt="Eye" />}
                            </div>
                        </div>

                        <div className="form-box">
                            <img src="/pictures/lock.png" alt="Lock" />
                            <input placeholder="Повторите пароль" type={secure ? "text" : "password"} value={repeat} onChange={event => this.setState({ repeat: event.target.value })} />
                            <div className="login-secure" onClick={() => this.setState({ secure: !secure })}>
                                {secure ? <img className="hide" src="/pictures/hide.png" alt="Eye" /> : <img src="/pictures/show.png" alt="Eye" />}
                            </div>
                        </div>

                        <button onClick={() => this.register()} disabled={loading} className="login-button">
                            {loading ? <LoadingOutlined /> : "Cоздать"}
                        </button>


                    </div>

                </div>

            </div>
        )
    }

}

export default withRouter(CreatePartner)